const env = process.env.REACT_APP_ENV || "";

export const isTestingEnv = env === "testing";
export const isTestingAPIEnv = env === "testing-api";

export const canMonitor = !["testing", "testing-api"].includes(env);
